$(document).ready(function(){
  $('.banner_images').slick({
    dots: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  });
});





